import React, { useState } from "react";
import { ConfirmModalContent } from "styles/elements/main";
import { ModalComponent, ToastMessage } from "components";
import CreateDriverProfile from "./CreateDriverProfile";

function DriverComponentModal({ open, onClose }) {
    const [onSuccess, setOnSuccess] = useState(false);
    const [discardUpdate, setDiscardUpdate] = useState(false);
    const handleDiscardUpdate = () => {
        setDiscardUpdate(!discardUpdate);
    };
    const handleCloseModal = () => {
        onClose();
        setDiscardUpdate(false);
    };
    return (
        <>
            <ModalComponent
                header="New driver"
                size="large"
                open={open}
                onClose={handleDiscardUpdate}
                borderedHeader
            >
                <CreateDriverProfile
                    onClose={onClose}
                    handleDiscardUpdate={handleDiscardUpdate}
                    setOnSuccess={setOnSuccess}
                />
                {discardUpdate && (
                    <ModalComponent
                        header="Leave “Update driver app Account” Page"
                        borderedHeader
                        isFooter
                        cancelBtn
                        submitBtn
                        open={discardUpdate}
                        submitBtnText="Leave"
                        onSubmit={handleCloseModal}
                        onClose={handleDiscardUpdate}
                    >
                        <ConfirmModalContent>
                            You have unsaved changes that will be lost if you leave the page.
                        </ConfirmModalContent>
                    </ModalComponent>
                )}
            </ModalComponent>
            {onSuccess && (
                <ToastMessage
                    name="driver"
                    type="success"
                    showToast={onSuccess}
                    setShowToast={setOnSuccess}
                    text="has been created successfully and is pending
                    verification."
                />
            )}
        </>
    );
}

export default DriverComponentModal;
